module.exports = __webpack_public_path__ + "static/img/14001006.7af99925.png";